import React, { ReactElement } from "react";
import Avatar from "react-avatar";
import { useNavigate, useLocation } from "react-router-dom";
import { Logout } from "../../Components/Auth/isAuthenticated";
import { getAppUserMe } from "../../Services/AppUser";
import { IRestGetUserMe } from "../../Services/Interfaces";
import { baseURL } from "../../Services/Api";
import {
  SidebarHeaderContainer,
  Sidebar,
  SidebarMenu,
  LogoArea,
  LogoMenu,
  LogoDivider,
  MenuContainer,
  MenuItemWrapper,
  MenuItemLabel,
  MenuItemIcon,
  SidebarFooter,
  SidebarFooterLink,
  CopyrightContainer,
  HeaderContent,
  Header,
  ComponentContent,
  HideItemDesk,
  LinkA,
} from "./styles";

// ─── Inline SVG Icons ──────────────────────────────────────────────────────────

const ic = (path: React.ReactNode) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {path}
  </svg>
);

const Icons = {
  Dashboard:       ic(<><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></>),
  Banners:         ic(<><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></>),
  Momentos:        ic(<><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></>),
  Eventos:         ic(<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>),
  Palestrantes:    ic(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="23" y1="21" x2="23" y2="19"/><line x1="19" y1="21" x2="19" y2="19"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>),
  Estabelecimentos:ic(<><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>),
  Usuarios:        ic(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>),
  Planos:          ic(<><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>),
  MeuPerfil:       ic(<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>),
  Relatorios:      ic(<><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>),
  TermosDeUso:     ic(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></>),
  Logout:          ic(<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>),
};

// ─── Menu definition ───────────────────────────────────────────────────────────

const MENU_ITEMS = [
  { path: "/home",                         label: "Visão Geral",               icon: Icons.Dashboard        },
  { path: "/banner",                       label: "Banner",                    icon: Icons.Banners          },
  { path: "/momentos-institucionais",      label: "Momentos Institucionais",   icon: Icons.Momentos         },
  { path: "/eventos",                      label: "Eventos",                   icon: Icons.Eventos          },
  { path: "/speaker",                      label: "Palestrantes",              icon: Icons.Palestrantes     },
  { path: "/UserManagement",               label: "Usuários Aplicativo",       icon: Icons.Usuarios         },
  { path: "/UserAdminRegister",            label: "Usuários Administrativos",  icon: Icons.MeuPerfil        },
  { path: "/EstablishmentsRegistration",   label: "Estabelecimentos",          icon: Icons.Estabelecimentos },
  { path: "/PlatformReport",              label: "Relatórios",                icon: Icons.Relatorios       },
  { path: "/EstabilishmentUserManagement", label: "Usuários Estabelecimento",  icon: Icons.Usuarios         },
];

// ─── Component ─────────────────────────────────────────────────────────────────

interface PageHeaderProps {
  InternalComponent: ReactElement<any, any>;
}

const PageHeaderUser: React.FC<PageHeaderProps> = ({ InternalComponent }) => {
  const navigate  = useNavigate();
  const location  = useLocation();

  const getName = () => localStorage.getItem("fullName") || "Name";

  const RotaUser = (path: string) => {
    getAppUserMe().then((response) => {
      const { data } = response as IRestGetUserMe;
      if (data) navigate(`${path}/${data.data.id}`);
    });
  };

  // Sem replace. Com replace em toda navegação o histórico nunca crescia:
  // cada clique sobrescrevia a entrada atual, então o "voltar" do navegador
  // pulava para fora do painel em vez de ir para a tela anterior.
  const Rota = (path: string) => navigate(path);

  const LogOut = () => {
    Logout();
    navigate("/login", { replace: true });
  };

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <SidebarHeaderContainer>

      {/* ── Sidebar ─────────────────────────────────────────────────────────── */}
      <Sidebar>
        <SidebarMenu>

          {/* Logo */}
          <LogoArea>
            <LogoMenu
              src="/Pertalks2.png"
              alt="Pertalks"
              onClick={() => Rota("/home")}
            />
          </LogoArea>
          <LogoDivider />

          {/* Menu items */}
          <MenuContainer>
            {MENU_ITEMS.map((item) => (
              <MenuItemWrapper
                key={item.path}
                active={isActive(item.path)}
                onClick={() => Rota(item.path)}
              >
                <MenuItemIcon>{item.icon}</MenuItemIcon>
                <MenuItemLabel>{item.label}</MenuItemLabel>
              </MenuItemWrapper>
            ))}
          </MenuContainer>

        </SidebarMenu>

        {/* Footer: terms + logout */}
        <SidebarFooter>
          <CopyrightContainer>
            <LinkA
              primary="rgba(255,255,255,0.7)"
              target="_blank"
              href={baseURL + "/politica.html"}
              style={{ fontSize: 11, lineHeight: "1.5" }}
            >
              Termo de Uso e Política de Proteção<br />
              de Dados e Privacidade
            </LinkA>
          </CopyrightContainer>

          <SidebarFooterLink onClick={LogOut} style={{ marginTop: 12 }}>
            <MenuItemIcon>{Icons.Logout}</MenuItemIcon>
            <MenuItemLabel>Sair</MenuItemLabel>
          </SidebarFooterLink>
        </SidebarFooter>
      </Sidebar>

      {/* ── Main content ────────────────────────────────────────────────────── */}
      <HeaderContent>
        <Header>
          <HideItemDesk>
            <Avatar
              style={{ cursor: "pointer" }}
              onClick={() => RotaUser("/UserAdminRegister")}
              name={getName()}
              size="40"
              round={true}
              color="#b96ea5"
            />
          </HideItemDesk>
        </Header>

        <ComponentContent>
          {InternalComponent}
        </ComponentContent>
      </HeaderContent>

    </SidebarHeaderContainer>
  );
};

export default PageHeaderUser;